@let initErrorValues = initErrors();
@let wrongConversationErrors = wrongConversation();
@if (wrongConversationErrors && wrongConversationErrors.length > 0) {
  <div class="error-wrapper">
    <shared-global-error
      data-testid="global-error"
      [title]="'SHARED.ERRORS.CONVERSATION_NOT_FOUND.TITLE' | translate"
      [message]="'SHARED.ERRORS.CONVERSATION_NOT_FOUND.MESSAGE' | translate"
      [unknownError]="true"
      [globalErrorType]="'conversation-not-found'"
      [hasReload]="false"
      (reload)="reload()" />
  </div>
} @else if (initErrorValues && initErrorValues.length > 0 && initErrorValues[0]) {
  <div class="error-wrapper">
    @let error = initErrorValues[0];
    <shared-global-error
      data-testid="global-error"
      [title]="error.title ?? 'error.global.title' | translate"
      [message]="error.message ?? error.code | translate"
      [unknownError]="true"
      [globalErrorType]="'general-error'"
      [hasReload]="true"
      (reload)="reload()" />
  </div>
} @else {
  @let conversationType = conversation()?.conversationType;

  @if (!windowService.isWebView()) {
    <header class="wire-client-header-wrapper" data-testid="conversation-header">
      <shared-client-app-header
        [conversation]="conversation()"
        [conversationType]="conversationType" />
    </header>
  }

  <main class="wire-client-conversation" role="main">
    <shared-conversation
      data-testid="conversation"
      [conversationId]="conversation()?.id ?? ''"
      [files]="conversation()?.files ?? []"
      (filesChange)="handleFilesChange($event)"
      [loading]="conversation()?.messageSending ?? false"
      [messages]="messages()"
      [isConversationArchived]="conversation()?.archived ?? false"
      [messageIdsWithError]="messageIdsWithError()"
      [errors]="errors()"
      [messageInputController]="conversation()?.messageInput"
      [participant]="participant()"
      [senderType]="messageSenderTypeEnum.Client"
      [messageAppendLoading]="messageAppendLoading()"
      [messagePrependLoading]="messagePrependLoading()"
      [conversationAppType]="conversationAppType()"
      (sendMessage)="handleSendMessage($event)"
      (messageButtonClicked)="handleMessageButtonClick($event)"
      (assetClicked)="handleAssetClick($event)"
      (fetchForNewMessages)="fetchForNewMessages()"
      (scrolled)="handleDownScroll()"
      (scrolledUp)="handleUpScroll()"
      (messageRead)="handleMessageRead($event)"
      (scrolledToBottom)="handleScrolledToBottom($event)"
      (sendOpenLiveTrackerEvent)="handleIsOpenEvent($event)"
      (isTyping)="sendIsTypingEvent($event)"
      (refreshMessages)="refreshMessages()"
      (resendMessage)="handleResendMessage($event)"
      [otherTypingParticipants]="otherTypingParticipants()"
      [conversationParticipants]="conversation()?.participants ?? []"
      [nextMessageSourceId]="conversation()?.messageSourceId"
      [windowService]="windowService" />
  </main>
}
